import React from 'react';
import { styled } from '@teko/ds-mobile';

interface YoutubeFrameProps {
  embedId?: string;
  youtubeLink?: string;
  openInPopup?: boolean;
}

const StyledIframe = styled.iframe<{ openInPopup: boolean }>(
  ({ openInPopup }) => `
    position: relative;
    height: 100%;
    width: 100%;
    pointer-events: ${openInPopup ? 'none' : 'auto'};
`,
);

export const YoutubeFrame: React.FC<YoutubeFrameProps> = ({
  embedId,
  youtubeLink,
  openInPopup = false,
}: YoutubeFrameProps) => {
  const videoEmbedId = youtubeLink
    ? getIdFromYoutubeLink(youtubeLink)
    : embedId;
  if (!videoEmbedId) return null;
  return (
    <StyledIframe
      src={`https://www.youtube.com/embed/${videoEmbedId}`}
      allowFullScreen
      frameBorder="0"
      openInPopup={openInPopup}
    />
  );
};

const getIdFromYoutubeLink = (url: string) => {
  if (!url) return '';
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : '';
};
